import { ApprovalFlowListPage, ApprovalFlowEditPage, ApprovalFlowCreatePage } from './imports';

export const orderRoutes = [
  {
    path: 'orders',
    children: [
      { element: <ApprovalFlowListPage />, index: true },
      {
        path: 'approval-flow',
        children: [
          { element: <ApprovalFlowListPage />, index: true },
          { path: 'list', element: <ApprovalFlowListPage /> },
          { path: 'new', element: <ApprovalFlowCreatePage /> },
          { path: ':id/edit', element: <ApprovalFlowEditPage /> },
        ],
      },
    ],
  },
];
